import { render } from "./FreightRegiFormUnit.vue?vue&type=template&id=7b106fe4"
import script from "./FreightRegiFormUnit.vue?vue&type=script&lang=js"
export * from "./FreightRegiFormUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__